import { createActions } from 'redux-actions';

export const {
    bootstrapData,
} = createActions({
    bootstrapData: (blockId) => blockId,
}, { prefix: 'WIDGETS_HOT_TOURS' });
